import { RouteConfig } from 'vue-router'

import Fullscreen from '../layouts/Fullscreen.vue'
import Panel from '../layouts/Panel.vue'

const baseTemplateRoutes: Array<RouteConfig> = [
  {
    path: '',
    component: Panel,
    children: [
      {
        name: 'profile',
        path: '/profile',
        component: () => import('../pages/profile.vue'),
      },
      {
        name: 'Company',
        path: '/registration/company',
        component: () => import('../pages/registration/company/company.vue'),
      },
      {
        name: 'loyalty_system',
        path: '/loyalty-system',
        component: () => import('../pages/loyalty-system.vue'),
      },
    ]
  },
  {
    path: '',
    component: Fullscreen,
    children: [
      {

        name: 'payment_status',
        path: '/payment-status',
        component: () => import('../pages/payment-status/payment-status.vue'),

      },
      {
        name: 'notice_payment_status',
        path: '/notice-payment-status',
        meta: {
          requiresAuth: false
        },
        component: () => import('../pages/notice-payment-status/notice-payment-status.vue'),
      },
      {
        name: 'login',
        path: '/login',
        component: () => import('../pages/login.vue'),
      },
      {
        name: 'login_admin',
        path: '/693a1d7de3aa6bdc6ee41da7f228735f',
        component: (): any => import('../pages/login.vue'),
      },
    ]
  },
  {

    name: 'error_404',
    path: '*',
    component: (): any => import('../pages/Error404.vue'),
  },
]

export {
  baseTemplateRoutes
}
